<template>
  <base-material-card color="primary" icon="mdi-filter" inline class="px-5 py-3">
    <template v-slot:after-heading>
      <div class="display-1 font-weight-light">Filtros</div>
    </template>

    <v-container class="mt-7 py-0">
      <v-row v-for="(filtro, index) in filtros" :key="index" class="mt-n10">
        <v-col cols="12" md="3" class="col-campo pb-0">
          <v-autocomplete
            v-model="filtro.campo"
            class="campo-filtros mt-4"
            :items="orderedItems"
            clearable
            clear-icon="mdi-close-circle"
            dense
            label="Campo"
            no-data-text="Nenhum campo disponível"
            @change="clearThirdGroupInputValue(filtro)"
            @input="(campo) => updateFiltroType(filtro, campo)"
          />
        </v-col>

        <v-col cols="1" class="col-hint-valores mr-2">
          <span class="container-hint-valores ma-0 mt-5 pulse">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  <v-icon
                    id="btn-hint-valores"
                    size="30px"
                    color="primary"
                    @click="$refs.dialogHintValores.getHintValores(filtro.campo, view)"
                  >
                    mdi-help-circle-outline
                  </v-icon>
                </div>
              </template>
              <span>Clique aqui para obter dicas de valores</span>
            </v-tooltip>
          </span>
        </v-col>

        <v-col cols="12" md="3" class="col-filtro">
          <v-autocomplete
            v-model="filtro.funcao"
            :items="filterOptionsComputed(filtro.campo)"
            item-value="value"
            item-text="text"
            label="Filtro"
            no-data-text="Nenhum filtro disponível"
            @change="(changeFilterOperand(), clearThirdGroupInputValue(filtro))"
          />
        </v-col>

        <v-col class="col-valor mb-7" cols="12" md="4">
          <v-textarea
            v-if="filtro.funcao == 'IN' || filtro.funcao == 'NOT IN'"
            v-model="filtro.valor"
            :label="filtro.funcao == 'BETWEEN' ? 'Valor Inicial' : 'Valor'"
            rows="3"
            no-resize
            class="mb-0"
            hint="Um valor por linha"
            @input="(valor) => updateFiltroValor(filtro, valor)"
          />
          <div
            v-else-if="
              (filtro.type == 'date' || filtro.type == 'datetime') &&
              (filtro.funcao != '' || filtro.funcao != 'IS NULL' || filtro.funcao != 'IS NOT NULL')
            "
          >
            <v-menu
              v-if="filtro.campo && isMonthYearDate(filtro.campo)"
              v-model="menus3[index]"
              :close-on-content-click="false"
              :nudge-right="100"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs3 }">
                <v-text-field
                  v-model="filtro.monthFormatted"
                  v-mask="'##/####'"
                  type="tel"
                  :label="filtro.funcao == 'BETWEEN' ? 'Valor Inicial' : 'Valor'"
                  v-bind="attrs3"
                  @blur="
                    filtro.month = parseMonth(filtro.monthFormatted);
                    updateFiltroValor(filtro, filtro.month);
                  "
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="filtro.month"
                type="month"
                :landscape="false"
                locale="pt-br"
                @input="
                  menus3[index] = false;
                  updateFiltroValor(filtro, filtro.month);
                  filtro.monthFormatted = formatMonth(filtro.month);
                "
              />
            </v-menu>
            <v-menu
              v-else
              v-model="menus[index]"
              :close-on-content-click="false"
              :nudge-right="100"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="filtro.dateFormatted"
                  v-mask="'##/##/####'"
                  :disabled="filtro.funcao == '' || filtro.funcao == 'IS NULL' || filtro.funcao == 'IS NOT NULL'"
                  :label="filtro.funcao == 'BETWEEN' ? 'Valor Inicial' : 'Valor'"
                  v-bind="attrs"
                  @blur="
                    filtro.date = parseDate(filtro.dateFormatted);
                    updateFiltroValor(filtro, filtro.date);
                  "
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="filtro.date"
                locale="pt-br"
                @input="
                  menus[index] = false;
                  updateFiltroValor(filtro, filtro.date);
                  filtro.dateFormatted = formatDate(filtro.date);
                "
              />
            </v-menu>
            <span v-if="filtro.funcao == 'BETWEEN'">e</span>
            <div v-if="filtro.funcao == 'BETWEEN'">
              <v-menu
                v-if="filtro.campo && isMonthYearDate(filtro.campo)"
                v-model="menus4[index]"
                :close-on-content-click="false"
                :nudge-right="100"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs4 }">
                  <v-text-field
                    v-model="filtro.monthFormatted2"
                    v-mask="'##/####'"
                    type="tel"
                    label="Valor Final"
                    v-bind="attrs4"
                    @blur="
                      filtro.month2 = parseMonth(filtro.monthFormatted2);
                      updateFiltroValor(filtro, filtro.month2);
                    "
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="filtro.month2"
                  type="month"
                  :landscape="false"
                  locale="pt-br"
                  @input="
                    menus4[index] = false;
                    updateFiltroValorFinal(filtro, filtro.month2);
                    filtro.monthFormatted2 = formatMonth(filtro.month2);
                  "
                />
              </v-menu>

              <v-menu
                v-else
                v-model="menus2[index]"
                :close-on-content-click="false"
                :nudge-right="100"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs2 }">
                  <v-text-field
                    v-model="filtro.dateFormatted2"
                    v-mask="'##/##/####'"
                    label="Valor Final"
                    v-bind="attrs2"
                    @blur="
                      filtro.date2 = parseDate(filtro.dateFormatted2);
                      updateFiltroValorFinal(filtro, filtro.date2);
                    "
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="filtro.date2"
                  locale="pt-br"
                  @input="
                    menus2[index] = false;
                    updateFiltroValorFinal(filtro, filtro.date2);
                    filtro.dateFormatted2 = formatDate(filtro.date2);
                  "
                />
              </v-menu>
            </div>
          </div>
          <div v-else>
            <v-text-field
              v-model="filtro.valor"
              :disabled="filtro.funcao == '' || filtro.funcao == 'IS NULL' || filtro.funcao == 'IS NOT NULL'"
              :label="filtro.funcao == 'BETWEEN' ? 'Valor Inicial' : 'Valor'"
              @input="(valor) => updateFiltroValor(filtro, valor)"
            />
            <span v-if="filtro.funcao == 'BETWEEN'">e</span>
            <v-text-field
              v-if="filtro.funcao == 'BETWEEN'"
              v-model="filtro.valorFinal"
              label="Valor Final"
              @input="(valorFinal) => updateFiltroValorFinal(filtro, valorFinal)"
            />
          </div>
        </v-col>

        <v-col id="btn-add-remove-filtro" cols="11" md="1" class="col-actions-filtros mt-6 pl-1">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="#2B60D6" class="mr-2 px-2" min-width="0" icon fab x-small v-bind="attrs" @click="addFiltro" v-on="on">
                <v-icon small>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>Adicionar Filtro</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="error"
                class="ml-n3 px-2"
                min-width="0"
                icon
                fab
                x-small
                v-bind="attrs"
                @click="removeFiltro(index)"
                v-on="on"
              >
                <v-icon small>mdi-minus</v-icon>
              </v-btn>
            </template>
            <span>Remover Filtro</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-container>
    <dialog-hint-valores ref="dialogHintValores" :show-dialog="hintValoresDialog" @changeValue="hintValoresDialog = $event" />
  </base-material-card>
</template>

<script>
  import TabelasService from '@/services/TabelasService';
  import dateFormatterMixins from '@/mixins/dateFormatterMixins';

  export default {
    name: 'CamposFiltros',

    components: {
      DialogHintValores: () => import('@/components/relatorios/DialogHintValores')
    },

    mixins: [dateFormatterMixins],

    props: {
      items: {
        type: Array,
        default: () => []
      },
      consulta: {
        type: Object,
        default: () => {}
      },
      view: {
        type: String,
        default: ''
      }
    },

    data: () => ({
      menus: [false],
      menus2: [false],
      menus3: [false],
      menus4: [false],
      filtros: [
        {
          campo: '',
          funcao: '',
          valor: '',
          type: '',
          valorFinal: '',
          date: '',
          date2: '',
          dateFormatted: '',
          dateFormatted2: '',
          month: '',
          monthFormatted: '',
          month2: '',
          monthFormatted2: ''
        }
      ],

      filterOptions: [
        {
          function: '=',
          translate: '=',
          types: ['float', 'decimal', 'integer', 'biginteger', 'datetime', 'date', 'string', 'text']
        },
        {
          function: '≠',
          translate: '<>',
          types: ['float', 'decimal', 'integer', 'biginteger', 'datetime', 'date']
        },
        {
          function: '≥',
          translate: '>=',
          types: ['float', 'decimal', 'integer', 'biginteger', 'datetime', 'date']
        },
        {
          function: '≤',
          translate: '<=',
          types: ['float', 'decimal', 'integer', 'biginteger', 'datetime', 'date']
        },
        {
          function: '>',
          translate: '>',
          types: ['float', 'decimal', 'integer', 'biginteger', 'datetime', 'date']
        },
        {
          function: '<',
          translate: '<',
          types: ['float', 'decimal', 'integer', 'biginteger', 'datetime', 'date']
        },
        {
          function: 'Lista',
          translate: 'IN',
          types: ['integer', 'biginteger', 'string', 'text']
        },
        {
          function: 'Fora da Lista',
          translate: 'NOT IN',
          types: ['float', 'decimal', 'integer', 'biginteger', 'string', 'text']
        },
        {
          function: 'Entre',
          translate: 'BETWEEN',
          types: ['float', 'decimal', 'integer', 'biginteger', 'datetime', 'date']
        },
        {
          function: 'Vazio',
          translate: 'IS NULL',
          types: ['float', 'decimal', 'integer', 'biginteger', 'datetime', 'date', 'string', 'text']
        },
        {
          function: 'Não Vazio',
          translate: 'IS NOT NULL',
          types: ['float', 'decimal', 'integer', 'biginteger', 'datetime', 'date', 'string', 'text']
        },
        {
          function: 'Contém',
          translate: 'LIKE %X%',
          types: ['string', 'text']
        },
        {
          function: 'Não contém',
          translate: 'NOT LIKE %X%',
          types: ['string', 'text']
        },
        {
          function: 'Começa com',
          translate: 'LIKE X%',
          types: ['string', 'text']
        },
        {
          function: 'Termina com',
          translate: 'LIKE %X',
          types: ['string', 'text']
        }
      ],
      campoDataBase: 'DATA_BASE',
      search: '',
      selected: [],
      hintValoresDialog: false
    }),

    computed: {
      orderedItems() {
        return [...this.items].sort((a, b) => (a.text.toUpperCase() > b.text.toUpperCase() ? 1 : -1));
      },
      allSelected() {
        return this.selected.length === this.items.length;
      },
      categories() {
        const search = this.search.toLowerCase();

        if (!search) return this.items;

        return this.items.filter((item) => {
          const text = item.text.toLowerCase();

          return text.indexOf(search) > -1;
        });
      },
      selections() {
        const selections = [];

        for (const selection of this.selected) {
          selections.push(selection);
        }

        return selections;
      }
    },

    methods: {
      changeFilterOperand() {
        this.$forceUpdate();
      },

      clearThirdGroupInputValue(filtro) {
        setTimeout(() => {
          filtro.date = '';
          filtro.date2 = '';
          filtro.dateFormatted = '';
          filtro.dateFormatted2 = '';
          filtro.month = '';
          filtro.month2 = '';
          filtro.monthFormatted = '';
          filtro.monthFormatted2 = '';
          filtro.valor = '';
          filtro.valorFinal = '';
          this.$forceUpdate();
        }, 450);
      },

      getEmptyFilter() {
        return [
          {
            campo: '',
            funcao: '',
            valor: '',
            type: '',
            valorFinal: '',
            date: '',
            date2: '',
            dateFormatted: '',
            dateFormatted2: '',
            month: '',
            monthFormatted: '',
            month2: '',
            monthFormatted2: ''
          }
        ];
      },

      getConsultaFiltros() {
        if (Object.keys(this.filtros).length > 1) {
          return;
        }

        if (Object.keys(this.consulta).length === 0) {
          return;
        }

        const filtros = JSON.parse(this.consulta.estrutura_json).condicoes;
        let obj = {};
        let i = 0;
        this.filtros = this.getEmptyFilter();
        filtros.forEach((filtro) => {
          obj = {};
          obj = {
            campo: filtro.campo,
            funcao: filtro.criterio,
            valor: filtro.criterio == 'IN' || filtro.criterio == 'NOT IN' ? filtro.valores.join('\r\n') : filtro.valores[0],
            type: this.translateClasse(filtro.classe),
            valorFinal: filtro.criterio == 'BETWEEN' ? filtro.valores[1] : '',
            date: filtro.classe == 'data' ? filtro.valores[0] : '',
            month: this.isMonthYearDate(filtro.campo) ? filtro.valores[0] : '',
            date2: filtro.classe == 'data' && filtro.criterio == 'BETWEEN' ? filtro.valores[1] : '',
            month2: this.isMonthYearDate(filtro.campo) ? filtro.valores[1] : '',
            dateFormatted: filtro.classe == 'data' || filtro.classe == 'data-hora' ? this.formatDate(filtro.valores[0]) : '',
            monthFormatted: this.isMonthYearDate(filtro.campo) ? this.formatMonth(filtro.valores[0]) : '',
            dateFormatted2:
              ['data', 'data-hora'].includes(filtro.classe) && filtro.criterio == 'BETWEEN'
                ? this.formatDate(filtro.valores[1])
                : '',
            monthFormatted2: this.isMonthYearDate(filtro.campo) ? this.formatMonth(filtro.valores[1]) : ''
          };
          //this.filtros[i] = obj;
          this.$set(this.filtros, i, obj);

          if (filtro.criterio == 'IN' || filtro.criterio == 'NOT IN') {
            this.updateFiltroValor(this.filtros[i], this.filtros[i].valor);
          } else {
            this.updateFiltroValor(this.filtros[i], filtro.valores[0]);
          }

          this.updateFiltroValorFinal(this.filtros[i], filtro.valores[1]);
          this.$forceUpdate();
          i++;
        });
      },

      translateClasse(classe) {
        switch (classe) {
          case 'inteiro':
            return 'integer';
          case 'float':
          case 'decimal':
            return 'integer';
          case 'data':
            return 'date';
          case 'data-hora':
            return 'datetime';
          default:
            return 'string';
        }
      },

      translateFuncao(funcao) {
        switch (funcao) {
          case 'IN':
            return 'Lista';
          case 'NOT IN':
            return 'Fora da Lista';
          case 'BETWEEN':
            return 'Entre';
          case 'IS NOT NULL':
            return 'Não vazio';
          case 'IS NULL':
            return 'Vazio';
          case '<>':
            return '≠';
          case '>=':
            return '≥';
          case '<=':
            return '≤';
          case 'LIKE %X%':
            return 'Contém';
          case 'NOT LIKE %X%':
            return 'Não contém';
          default:
            return funcao;
        }
      },

      getUltimaDataBase(view) {
        return TabelasService.getTabelaResumo()
          .then((response) => {
            if (view == 'view_georreferenciado') {
              return response.data.tabela_resumo.data_base_bdgd;
            } else if (view == 'view_registros_ais') {
              return response.data.tabela_resumo.data_base_ais;
            } else if (view == 'view_laudo_blindado') {
              return response.data.tabela_resumo.data_base_laudo_blindado;
            }
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao recuperar última data base', '', { position: 'topRight' });
          });
      },

      exportCampos() {
        let isValid = this.validarFiltros(this.filtros);
        return isValid ? this.filtros : 'invalido';
      },

      getCampoTipo(campo) {
        let arrayCampo = [];

        arrayCampo = this.items.filter((element) => {
          return element.text == campo;
        });

        if (arrayCampo[0]) {
          return arrayCampo[0].type;
        }

        return '';
      },

      updateFiltroType(filtro, campo) {
        this.items.forEach((item) => {
          if (item.text == campo) {
            filtro.type = item.type;
          }
        });
        this.$forceUpdate();
      },

      updateFiltroValor(filtro, valor) {
        if (this.isMonthYearDate(filtro.campo)) {
          if (valor && valor.length <= 7) {
            filtro.valor = valor + '-01';
          }
        } else {
          filtro.valor = valor;
        }
        this.$forceUpdate();
      },

      updateFiltroValorFinal(filtro, valorFinal) {
        if (this.isMonthYearDate(filtro.campo)) {
          if (valorFinal && valorFinal.length <= 7) {
            filtro.valorFinal = valorFinal + '-01';
          }
        } else {
          filtro.valorFinal = valorFinal;
        }
        this.$forceUpdate();
      },

      filterOptionsComputed: function (campo) {
        let arrayCampo = [];
        let arrayFiltro = [];

        arrayCampo = this.items.filter((element) => {
          return element.text == campo;
        });

        if (arrayCampo[0]) {
          arrayFiltro = this.filterOptions.filter((el) => {
            return el.types.indexOf(arrayCampo[0].type) !== -1;
          });

          return arrayFiltro.map((e) => {
            return { text: e.function, value: e.translate };
          });
        }

        return [];
      },

      addFiltro() {
        let obj = {
          campo: '',
          funcao: '',
          type: '',
          valor: '',
          valorFinal: '',
          date: '',
          date2: '',
          dateFormatted: '',
          dateFormatted2: '',
          month: '',
          monthFormatted: '',
          month2: '',
          monthFormatted2: ''
        };

        this.filtros.push(obj);
        this.menus.push(false);
        this.menus2.push(false);
        this.menus3.push(false);
        this.menus4.push(false);
      },

      removeFiltro(target) {
        if (this.filtros.length <= 1) {
          this.filtros = this.getEmptyFilter();
        } else {
          this.filtros.splice(target, 1);
          this.menus.splice(target, 1);
          this.menus2.splice(target, 1);
          this.menus3.splice(target, 1);
          this.menus4.splice(target, 1);
        }
      },

      validarFiltros(filtros) {
        let retorno = true;

        filtros.forEach((filtro) => {
          /* Caso o campo de data for do tipo month, ira validar se o valor corresponde a ##/#### e se é valido */
          if (filtro.monthFormatted && (filtro.monthFormatted.indexOf('undefined') != -1 || filtro.monthFormatted.length != 7)) {
            this.$toast.warning(`O filtro [${filtro.campo}] deve estar no formato: ##/####.`, '', { position: 'topRight' });
            retorno = false;
          } else if (
            filtro.monthFormatted2 &&
            (filtro.monthFormatted2.indexOf('undefined') != -1 || filtro.monthFormatted2.length != 7)
          ) {
            this.$toast.warning(`O filtro [${filtro.campo}] deve estar no formato: ##/####.`, '', { position: 'topRight' });
            retorno = false;
          }

          /* Caso o campo de data for do tipo date, ira validar se o valor corresponde a ##/##/#### e se é valido */
          if (filtro.dateFormatted && (filtro.dateFormatted.indexOf('undefined') != -1 || filtro.dateFormatted.length != 10)) {
            this.$toast.warning(`O filtro [${filtro.campo}] deve estar no formato: ##/##/####.`, '', { position: 'topRight' });
            retorno = false;
          } else if (
            filtro.dateFormatted2 &&
            (filtro.dateFormatted2.indexOf('undefined') != -1 || filtro.dateFormatted2.length != 10)
          ) {
            this.$toast.warning(`O filtro [${filtro.campo}] deve estar no formato: ##/##/####.`, '', { position: 'topRight' });
            retorno = false;
          }

          if (filtro.campo && filtro.funcao.trim() == '') {
            this.$toast.warning(`Função para utilização do filtro [${filtro.campo}] não informado.`, '', {
              position: 'topRight'
            });
            retorno = false;
          }
        });

        return retorno;
      },

      isMonthYearDate(campo) {
        return ['DATA_BASE', 'MES_ANO_DATA_LANCAMENTO'].includes(campo.toUpperCase());
      }
    },

    watch: {
      selected() {
        this.search = '';
      },
      async view() {
        if (
          ['view_registros_ais', 'view_georreferenciado', 'view_laudo_blindado'].includes(this.view) &&
          !this.$route.params.id
        ) {
          let ultimaDataBase = await this.getUltimaDataBase(this.view);

          let obj = {
            campo: 'DATA_BASE',
            funcao: '=',
            type: 'date',
            valor: '',
            valorFinal: '',
            date: '',
            month: ultimaDataBase,
            date2: '',
            dateFormatted: '',
            monthFormatted: this.formatMonth(ultimaDataBase),
            month2: '',
            dateFormatted2: '',
            monthFormatted2: ''
          };

          this.filtros = this.getEmptyFilter();
          this.filtros[0] = obj;

          this.updateFiltroValor(this.filtros[0], ultimaDataBase);

          this.$forceUpdate();
        } else {
          this.filtros = this.getEmptyFilter();
          this.$forceUpdate();
        }
      },
      orderedItems() {
        this.getConsultaFiltros();
      }
    }
  };
</script>

<style>
  .col-hint-valores {
    display: flex;
    justify-content: center;
    max-width: 3%;
  }

  .container-hint-valores {
    width: 31px;
    height: 31px;
    text-align: center;
  }

  .campo-filtros .v-select__slot {
    padding-top: 6px;
  }

  @media screen and (max-width: 1265px) {
    .col-actions-filtros {
      padding: 10px 0 0 0 !important;
    }
  }

  @media screen and (max-width: 958px) {
    .col-campo {
      max-width: 84% !important;
    }
    .col-hint-valores {
      max-width: 16% !important;
    }
    .col-valor {
      max-width: 84% !important;
      padding-top: 0px !important;
    }
    .col-actions-filtros {
      max-width: 16% !important;
      padding: 0 !important;
    }
    .col-filtro {
      max-width: 84% !important;
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }
  }

  @media screen and (max-width: 450px) {
    .col-campo {
      max-width: 75% !important;
    }
    .col-hint-valores {
      max-width: 25% !important;
    }
    .col-valor {
      max-width: 75% !important;
    }
    .col-actions-filtros {
      max-width: 25% !important;
      padding: 0 !important;
    }
  }
</style>
